module.exports = __webpack_public_path__ + "static/media/partners_sebrae.b9a6fe75.jpg";